import { IFilterItem } from "../models/filter-item-model";
import { IFixedFilter } from "@/shared/models/view/fixed-filter-model";
import { IDictionary } from "@/shared/models/interface/dictionary-model";
import { IFilterQueryService } from "./interfaces/filter-query-service-interface";

export abstract class BaseFilterQueryService implements IFilterQueryService {
    public filter: string = '';

    public abstract addUserFilter(filters: IDictionary<IFilterItem[]>): BaseFilterQueryService

    public addFixedFilter(fixedFilters: IDictionary<IFixedFilter>): BaseFilterQueryService {
        this.addContentTypeFilter(fixedFilters);
        Object.keys(fixedFilters)?.forEach((name) => {
            fixedFilters[name]?.Values.forEach((value) => {
                switch (name) {
                    case "Language":
                        this.appendFilter(this.getSingleSyntax(name, value, fixedFilters[name].LogicalOperator));
                        break;
                    case "ContentType":
                        // This can be skipped because it is set in addContentTypeFilter()
                        break;
                    default:
                        this.appendFilter(this.getListSyntax(name, [value]));
                        break;
                }
            })
        })

        return this
    }

    public addContentTypeFilter(fixedFilters: IDictionary<IFixedFilter>): void {
        var fixedFilter = fixedFilters["ContentType"];

        if (fixedFilter) {
            var values = fixedFilter.Values ?? [];

            if (values.length == 1) {
                let filter = this.getSingleSyntax("ContentType", values[0], fixedFilter.LogicalOperator)
                this.appendFilter(filter);
            }
            else if (values.length > 1) {
                let filters: string[] = [];
                values.forEach((value) => {
                    let filter = this.getSingleSyntax("ContentType", value, fixedFilter.LogicalOperator)
                    filters.push(filter);
                });
                this.appendFilter('(' + filters.join(' or ') + ')');
            }
        }
    }

    public addScopesFilter(scopes: IFilterItem[]): BaseFilterQueryService {
        if (scopes && scopes.length) {
            let query = this.getListSyntax('Scopes', scopes.map(x => x.CodeName))
            this.appendFilter(query)
        }

        return this
    }

    public appendFilter(filter: string): void {
        this.filter = this.filter ? `${this.filter} and ${filter}` : filter;
    }

    public getSingleSyntax(filter: string, value: string, logicalOperator: string): string {
        return `${filter} ${logicalOperator} '${value}'`;
    }

    public getListSyntax(filter: string, values: string[]): string {
        return `${filter}/any(c: search.in(c, '${values.join('|')}', '|'))`;
    }
}


